"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = void 0;
// eslint-disable-next-line
function assertUnreachable(_) {
    throw new Error('assertUnreachable');
}
exports.assertUnreachable = assertUnreachable;
//# sourceMappingURL=assertUnreachable.js.map